import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

export interface IsShowDetailsButtonState {
    value: boolean;
}

const initialState: IsShowDetailsButtonState = {
    value: false,
};

export const isShowDetailsButtonSlice = createSlice({
    name: 'isShowDetailsButtonSetter',
    initialState,
    reducers: {
        setIsShowDetailsButton: (state, action: PayloadAction<boolean>) => {
            state.value = action.payload;
        },
    },
});

export const { setIsShowDetailsButton } = isShowDetailsButtonSlice.actions;
export default isShowDetailsButtonSlice.reducer;